import { SuperiorEvaluationData } from "./superiorEvaluationData.model"
import { LandlordData } from "./landlordData.model"
import { AdultFamilyMember } from "./adultFamilyMember.model"

export enum ApplicationState {
    Draft = "draft",
    Submitted = "submitted",
    Cancelled = "cancelled",
    Approved = "approved",
    ContractGenerated = "contract_generated",
    SignedContractsUploaded = "signed_contracts_uploaded",
    SubsidyInProgress = "subsidy_in_progress",
    Rejected = "rejected",
    Illegal = "illegal",
    WaitingSuperior = "waiting_superior",
    WaitingCommission = "waiting_commission",
}

export const applicationStateNames: Record<ApplicationState, string> = {
    [ApplicationState.Draft]: "Započeta",
    [ApplicationState.Submitted]: "Potvrđena od strane korisnika",
    [ApplicationState.Cancelled]: "Otkazana",
    [ApplicationState.Approved]: "Potvrđena",
    [ApplicationState.ContractGenerated]: "Generirani ugovori",
    [ApplicationState.SignedContractsUploaded]: "Potpisani ugovori predani",
    [ApplicationState.SubsidyInProgress]: "Subvencija u tijeku",
    [ApplicationState.Rejected]: "Odbijena",
    [ApplicationState.Illegal]: "Nevaljana",
    [ApplicationState.WaitingSuperior]: "Čekanje procjene nadređenog",
    [ApplicationState.WaitingCommission]: "Spremna za komisiju",
}

export interface Application {
    masterId: string
    createdByUser: string
    modifiedByUser: string
    createdDate: Date
    modifiedDate: Date
    version: number
    state: ApplicationState
    mbrad: string
    employeeId: string
    name: string
    surname: string
    oib: string
    residenceAddress: string
    mobile: string
    email: string
    numberOfFamilyMembers: number
    employeeMonthlyIncome: number
    isSingleParent: boolean
    numberOfChildren: number
    currentAccomodation: string
    employeePropertyDocument: string
    ownsPropertyCloserThan30Km: boolean
    ownsPropertyFurtherThan30Km: boolean
    ownsLeaseAgreement: boolean
    lookingForApartment: boolean
    consentsToPrivacyPolicy: boolean
    adultFamilyMembers: AdultFamilyMember[]
    minorFamilyMembersBirthCertificates: string[]
    singleParentConfirmation: string
    residenceCertificate: string
    superiorEvaluationData: SuperiorEvaluationData | null
    landlordData: LandlordData | null
    contractStartDate?: string | null
    contractEndDate?: string | null
    rentalAgreement: string
    subrentalAgreement: string
}
